//@flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PopupInputUIState.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { observable, action } from 'mobx';
import { isFunction } from 'lodash/fp';
class PopupInputUIState {
  @observable hadSetting = null;
  @observable value = null;
  @observable settingValue = null;

  @action
  update(props: Object) {
    this.value = isFunction(props.loadValue) ? props.loadValue() : props.value;
    this.settingValue = isFunction(props.loadValue) ? props.loadValue() : props.settingValue;
    this.hadSetting = isFunction(props.hadSetting) ? props.hadSetting() : props.hadSetting;
  }
}

export default PopupInputUIState;



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.PopupInputUIState.js